import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {InsoleDataElementModel} from "./insoleDataElement.model";
import {
    InsoleElementDefinitionSummaryConverter
} from "../../../../../element/definition/api/model/insoleElementDefinitionSummary.converter";
import {LovValueSummaryConverter} from "../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsoleDataElementConverter extends HttpModelConverter<InsoleDataElementModel> {

    constructor(private definitionSummaryConverter: InsoleElementDefinitionSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): InsoleDataElementModel {
        return new InsoleDataElementModel();
    }

    protected enrichObject(result: InsoleDataElementModel, src: InsoleDataElementModel) {
        result.definition = this.definitionSummaryConverter.convert(src.definition);
        result.positionValue = this.lovValueSummaryConverter.convert(src.positionValue);
    }

}
